export const Keys = {
    AuthUser: 'AD Portal.AuthUser',
    AuthToken: 'AD Portal.AuthToken',  
}